export const hasAccessByRole = ({ allowedRoles, role }: { allowedRoles: string[]; role?: string | null }): boolean => {
  return !!role && allowedRoles.includes(role);
};

export const isFeatureEnabled = ({
  allowedFeatures = [],
  feature,
}: {
  feature: string;
  allowedFeatures?: string[];
}): boolean => {
  if (!Array.isArray(allowedFeatures)) {
    console.warn('Allowed features is not an array!');
    return false;
  }
  return allowedFeatures.includes(feature);
};
